import React, { useCallback, useEffect, useRef, useState } from "react";
import * as ReactDOMClient from 'react-dom/client';
// @ts-ignore
import Modal from "bootstrap/js/dist/modal";
import { LeaderboardProvider, useLeaderboard, } from "@/common/store/Leaderboard/LoaderboardProvider";
import { getParticipantFilter, getTimeFilter } from "./constants";
import FilterModal from "./components/FilterModal";
import { leaderboardActions } from "@/common/store/Leaderboard/actions";
import LeaderboardHeader from "./components/LeaderboardHeader";
import UserParticipant from "./Participant/UserParticipant";
import TeamParticipant from "./Team/TeamParticipant";
import PrevButton from "./components/PrevButton";
import NextButton from "./components/NextButton";
import MVMIcon from "../Common/MVMIcon";
const Leaderboard = () => {
    const { state, dispatch } = useLeaderboard();
    const topRef = useRef(null);
    const teamRef = useRef(null);
    //@ts-ignore
    const distanceTarget = window.distanceTarget;
    const [modal, setModal] = useState();
    const [userKey, setUserKey] = useState("");
    const onModalButtonClick = () => {
        if (!modal || !modal._isShown) {
            openModal();
        }
        else {
            modal.hide();
        }
    };
    const openModal = () => {
        if (modal) {
            modal.show();
        }
        else {
            const modalOnLoad = new Modal(document.getElementById("modal-leaderboard-filter"));
            modalOnLoad.show();
            setModal(modalOnLoad);
        }
    };
    const onGoToTop = () => {
        if (topRef.current) {
            //@ts-ignore
            topRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };
    const onGoToUser = () => {
        const elementPosition = document.getElementById(userKey)?.offsetTop;
        if (!elementPosition) {
            return;
        }
        window.scrollTo({
            top: elementPosition - 70,
            behavior: "smooth",
        });
        if (userKey.split("_")[0] === "team") {
            //@ts-ignore
            teamRef.current?.openTeam(elementPosition);
        }
    };
    const getLeaderboard = (values) => {
        if (!state || !dispatch)
            return;
        const newFilter = {
            ...state.filter,
            ...values,
            version: "",
            cursor: null,
        };
        leaderboardActions.getLeaderboard(newFilter, dispatch);
        modal.hide();
    };
    const updateLeaderboardStart = () => {
        if (!state || !dispatch)
            return;
        const newFilter = {
            ...state.filter,
            cursor: state.prevCursor,
        };
        leaderboardActions.loadMoreLeaderboardStart(newFilter, dispatch);
    };
    const updateLeaderboardEnd = () => {
        if (!state || !dispatch)
            return;
        const newFilter = {
            ...state.filter,
            cursor: state.nextCursor,
        };
        leaderboardActions.loadMoreLeaderboardEnd(newFilter, dispatch);
    };
    if (!state) {
        return null;
    }
    const renderParticipantsList = () => {
        const maxRank = state.maxRank ?? 1;
        const distanceUnit = state.distanceUnit ?? "km";
        return state.pages.map((participants, pageIndex) => participants.map((participant, participantIndex) => {
            const isLastFromList = pageIndex + 1 === state.pages.length &&
                participantIndex + 1 === participants.length;
            const participantKey = `${participant.type}_${participant.id}`;
            if (participant.type === "user") {
                return (React.createElement("div", { key: participantKey, id: participantKey, className: !isLastFromList ? "border-bottom" : "" },
                    React.createElement(UserParticipant, { maxRank: maxRank, participant: participant, distanceUnit: distanceUnit, totalMissionDistance: distanceTarget })));
            }
            return (React.createElement("div", { key: participantKey, id: participantKey, className: !isLastFromList ? "border-bottom" : "" },
                React.createElement(TeamParticipant, { ref: participant.isCurrentUser ? teamRef : undefined, maxRank: maxRank, participant: participant, distanceUnit: distanceUnit, totalMissionDistance: distanceTarget, pageIndex: pageIndex, participantIndex: participantIndex, distanceTarget: distanceTarget })));
        }));
    };
    useEffect(() => {
        if (state) {
            let key = null;
            state.pages.map((page) => page.map((participant) => {
                if (participant.isCurrentUser) {
                    key = `${participant.type}_${participant.id}`;
                }
            }));
            if (key !== null) {
                setUserKey(key);
            }
        }
    }, [state]);
    const renderLeaderboardList = useCallback(() => {
        if (state.pages[0].length <= 0) {
            return (React.createElement("div", { className: "pt-5 d-flex flex-column justify-content-center align-items-center" },
                React.createElement(MVMIcon, { icon: "trophy", className: "dark-grey", width: 75, height: 75 }),
                React.createElement("p", { className: "weight-600 mb-0 mt-2" }, "The leaderboard is empty!")));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(LeaderboardHeader, { goToUser: onGoToUser, goToTop: onGoToTop }),
            React.createElement(PrevButton, { cursor: state.prevCursor, onClick: updateLeaderboardStart }),
            React.createElement("div", { id: "participantsAccordion" }, renderParticipantsList()),
            React.createElement(NextButton, { cursor: state.nextCursor, onClick: updateLeaderboardEnd })));
    }, [state]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row flex-column-reverse flex-md-row mb-5", 
            //@ts-ignore
            ref: topRef, id: "leaderboard" },
            React.createElement("div", { className: "col" }, renderLeaderboardList()),
            React.createElement("div", { className: "col" },
                React.createElement("div", { className: "sticky-top text-center" },
                    React.createElement("p", { className: "pt-5" },
                        "Display will show",
                        " ",
                        React.createElement("span", { className: "weight-600 secondary-color" }, getTimeFilter(state.filter.filterPeriod)),
                        " ",
                        "leaderboard of",
                        " ",
                        React.createElement("span", { className: "weight-600 secondary-color" }, getParticipantFilter(state.filter.leaderboardType)),
                        "."),
                    React.createElement("button", { className: "small-btn-primary", onClick: onModalButtonClick }, "UPDATE FILTERS")))),
        React.createElement(FilterModal, { onSubmit: getLeaderboard })));
};
const rctLeaderboard = document.getElementById("rct-leaderboard");
if (rctLeaderboard !== null) {
    ReactDOMClient.createRoot(rctLeaderboard).render(React.createElement(LeaderboardProvider, null,
        React.createElement(Leaderboard, null)));
}
